import { Link, useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { FormRunner } from "@/components/forms/FormRunner";
import { ImportantNote } from "@/components/ImportantNote";

export default function InPersonIntakePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const qc = useQueryClient();
  const { data: kase, isLoading } = useQuery({ queryKey: ["portal", "case"], queryFn: async () => (await api.get("/portal/case")).data });

  const onSubmitted = (result) => {
    qc.invalidateQueries({ queryKey: ["portal"] });
    toast.success(result.state === "matching" ? "Thank you. We are matching you with a counselor." : "Thank you. Your In-Person Intake is complete.");
    navigate("/portal");
  };

  if (isLoading) return <p className="p-10 text-ink-500" role="status">Loading…</p>;
  const locked = !user.email_verified || !kase || kase.state !== "certificate_issued";
  if (locked) {
    return (
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-testid="in-person-intake-locked">
        <h1 className="text-4xl">In-Person Intake</h1>
        <div className="surface mt-8 max-w-xl p-6">
          <p className="font-serif text-xl font-semibold">{kase && ["in_person_intake_submitted", "matching", "active"].includes(kase.state) ? "Your In-Person Intake Is Already In" : "Finish Your Video Series First"}</p>
          <p className="mt-2">{kase && ["in_person_intake_submitted", "matching", "active"].includes(kase.state) ? "Thank you. The care team has what it needs for now." : "The In-Person Intake opens the moment your video series certificate is issued."}</p>
          <Link to="/portal" className="btn-secondary mt-5">Back To My Care Journey</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6" data-testid="in-person-intake-page">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <h1 className="text-4xl sm:text-5xl">In-Person Intake</h1>
          <p className="mt-3 max-w-[55ch] text-ink-500">Consents, your story, and how you would like to be matched. Your answers save as you go. The optional Release of Information is printed in large type so it is easy to read and share.</p>
          <div className="mt-10"><FormRunner templateKey="in_person_intake" onSubmitted={onSubmitted} /></div>
        </div>
        <div className="lg:col-span-5"><ImportantNote /></div>
      </div>
    </div>
  );
}
